import { useEffect, useState } from "react";

export const useGeneratedFilterSelections = (pipelineOutput) => {
  const [generatedActiveFilters, setGeneratedActiveFilters] = useState([]);

  useEffect(() => {
    setGeneratedActiveFilters([]);
  }, [pipelineOutput]);

  return {
    generatedActiveFilters,
    setGeneratedActiveFilters,
  };
};


